import { DEFAULT_DELAYED_FALLBACK, DEFAULT_ERROR_FALLBACK } from '~/config/app.constants';

import type { TErrorBoundary, TSuspenseBoundary } from '../components/Renderer';
import Renderer from '../components/Renderer';

const withAsyncRendering = <P extends TErrorBoundary & TSuspenseBoundary>() => (
  Component: React.ComponentType<Omit<P, keyof TErrorBoundary | keyof TSuspenseBoundary>>
) => ({
  onError,
  errorFallback = DEFAULT_ERROR_FALLBACK,
  delayedFallback = DEFAULT_DELAYED_FALLBACK,
  ...props
}: P) => (
  <Renderer errorFallback={errorFallback} delayedFallback={delayedFallback} onError={onError}>
    <Component {...props} />
  </Renderer>
);

export default withAsyncRendering;
